import React from 'react';
import classNames from 'classnames';

import Icon from '../Icon';

/**
 *  A React component that renders a loading indicator when downloading LUX MED study.
 */
function DownloadIndicatorProgress({ className, done }) {
  return (
    <div
      className={classNames("flex: 1",
        className
      )}
    >{done ? (
      <Icon
        name="loading-luxmed-done"
      />
    ) : (
      <Icon
        name="loading-luxmed-mark"
      />
    )}
    </div>
  );
}

export default DownloadIndicatorProgress;
